import * as Yup from "yup";

export const loginValidation = Yup.object({
  username: Yup.string().email("Email must be a valid email address").required("Email is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters long")
    .required("Password is required"),
});
